export enum DeviceCommunicationType {
    Job,
    Message,
    SetOdometer,
    Restart,
    ConfigUpdate,
    SetPrimaryApn,
    SetPrimaryApnPassword,
    SetSecondaryApn,
    SetSecondaryApnPassword,
    ForcePlotReport,
    DeleteAllQueuedMessages,
    SetSquarellDcf,
    SetSquarellFirmware,
    CalibrateAccelerometer,
    StartAccelerometer,
    GetSquarellThresholds,
    Custom,
    SetSquarellThresholds0to12,
    SetSquarellThresholds12to22,
    SetSquarellThresholds22up,
    CustomSquarellCommand134,
    GetSquarellExtendedVersion,
    GetSquarellFMS,
    GetSquarellParams,
    SetSquarellParams,
    CheckSquarellCalibration,
    SetPrimaryHostEndpoint,
    SetSecondaryHostEndpoint,
    SetHostPortNumber,
    CustomSquarellCommand135,
    TurnOffSerialData511,
    TurnOffSerialData580,
    TurnOffSerialData601,
    TurnOffSerialData602,
    TurnOffSerialData603,
    TurnOffSerialData604,
    TurnOffSerialData660,
    TurnOffSerialData850,
    SetTranscanClock,
    SetDeviceParameters,
    LoggingLevel,
    RemovePendingVideoRequests,
    CameraReboot,
    GetLogFile,
    TelematicsMode,
    GenericFileUpload,
    AdbPassthrough
}
